<template>
    <div class="pointPage">
        <ArrowButton @click="handlePoint">
            {{ $t('integration.record_point_setting') }}
        </ArrowButton>
        <!-- <div class="uk-flex uk-flex-middle" @click="handlePoint">
            <el-button type="primary" style="margin-right:-3px;"></el-button>
            <el-button style="border:none;margin-left: 0 !important;" type="primary">
                <i class="el-icon-d-arrow-right" style="color:white"></i>
            </el-button>
        </div> -->
        <!-- 记录点设置 -->
        <pointDialog v-if="isShow" :isShow.sync="isShow" v-bind="$attrs" :detailRow="detailRow" ref="pointDialog" />
    </div>
</template>

<script>
import pointDialog from './PointDialog.vue';
import { carrierDetail } from '@/api/modules/record.js';
import ArrowButton from '../../../../components/ArrowButton/ArrowButton.vue';
export default {
    components: {
        pointDialog,
        ArrowButton
    },
    data() {
        return {
            isShow: false,
            detailRow: {}
        };
    },
    methods: {
        handlePoint() {
            console.log(this.$attrs);
            this.isShow = true;
            this.$nextTick(() => {
                this.$refs['pointDialog'].getSence();
                this.$refs['pointDialog'].clearValidate();
            });
            if (!this.$attrs.scopeId) return;
            carrierDetail({ scopeId: this.$attrs.scopeId }).then(({ result }) => {
                this.detailRow = result;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.pointPage {
    position: absolute;
    right: 15px;
    top: 10px;
}
.btn {
    background-color: var(--primary-color) !important;
    ::v-deep i {
        color: #fff;
    }
}
</style>
